module.exports = __webpack_public_path__ + "static/media/snappy-monarx.5e1b0132.svg";